import React from 'react';
import { Box } from '@mui/material';
interface Props extends React.PropsWithChildren {}
export default function ColumnContent(props: Props) {
  const { children } = props;

  return (
    <Box
      sx={{
        minWidth: '300px',
        px: 5,
        overflowY: 'auto',
        height: '97%',
        overflowScrolling: 'touch',
        background: `
            /* Shadow Cover TOP */
            linear-gradient(
              white 30%,
              rgba(255, 255, 255, 0)
            ) center top,

            /* Shadow Cover BOTTOM */
            linear-gradient(
              rgba(255, 255, 255, 0),
              white 70%
            ) center bottom,

            /* Shadow TOP */
            radial-gradient(
              farthest-side at 50% 0,
              rgba(0, 0, 0, 0.2),
              rgba(0, 0, 0, 0)
            ) center top,

            /* Shadow BOTTOM */
            radial-gradient(
              farthest-side at 50% 100%,
              rgba(0, 0, 0, 0.2),
              rgba(0, 0, 0, 0)
            ) center bottom
        `,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 40px, 100% 40px, 100% 14px, 100% 14px',
        backgroundAttachment: 'local, local, scroll, scroll',
      }}
    >
      {children}
    </Box>
  );
}
